<template>
  <div>
    <template v-if="isIndex">
      <div class="sectionBox">
        <!-- 标题 -->
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <el-alert title="" type="warning" v-if="!apptitle">
          <span
            class="importantNote"
            v-for="item in appointment"
            :key="item.index"
          >
            <span>{{ item.examDate }}</span
            >预约考试人数<span style="margin-right: 20px"
              >{{ item.stuCount }}人</span
            >
          </span>
        </el-alert>
        <ots-refer
          class="mb20"
          :selectList="selectList"
          :request-form="sectionSelectParams"
          @search="getSectionList"
        />
        <!-- 列表 -->
        <div class="mainCon">
          <h4 class="mb20">考试批次：{{ planInfo.name }}</h4>
          <ots-table-group
            :tableHeader="tableHeader"
            :tableOption="tableOption"
            :tableData="tableData"
            :batchOperBtn="batchOperBtn"
            :pagination="pagination"
            @handleSelectionChange="bachOper"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>
<script>
import {
  getPlanSignDateCountShow,
  getCurrentPlanFn,
} from "@/http/modules/examSet/examBatch";
import {
  getSectionList,
  getPlanSite,
  deleteSessionFn,
  copySessionConfigAPI
} from "@/http/modules/examSet/section";
export default {
 
  data() {
    return {
      apptitle:false,
      appointment: [],
      selectSections: [],
      mainTopBtnList: [
        {
          title: "新增",
          fn: this.addPlanDialog,
        },
      ],

      btnList: [],

      tableHeader: [
        {
          title: "场次名称",
          prop: "name",
          width: "120",
        },
        {
          title: "开始时间",
          prop: "beginTime",
        },
        {
          title: "结束时间",
          prop: "endTime",
        },
        {
          title: "考试课程",
          prop: "courseNames",
          width: "150",
        },
        {
          title: "考点",
          prop: "placeNames",
        },
        {
          title: "操作",
          type: "buttons",
          width: "280",
          btnList: [
            // {
            //   title: "查看",
            //   click: this.checkSection,
            // },
            {
              title: "编辑",
              disable: (val) => (val.row.publish == 1 ? true : false),
              click: this.editSection,
            },
            {
              title: "删除",
              disableFn: (val) => {
                if (Math.ceil(this.pagination.total / this.sectionListParams.size) != this.sectionListParams.page) {
                  return true;
                } else {
                  return val.$index !== this.tableData.length - 1
                }
              },
              click: this.deleteSection,
            },
            {
              title: "场次配置",
              click: this.goVenue,
            }, 
            {
              title: "复制上一场次设置",
              click: this.copyConfig
            }
          ],
        },
      ],
      tableOption: {
        // multiple:true
      },
      tableData: [],
      batchOperBtn: [
        {
          title: "返回",
          click: () => {
            this.$router.push({ name: "sectionList" });
          },
        },
      ],
      pagination: {
        total: 0,
      },
      sectionSelectParams: {
        // planId: "",
        placeId: "",
      },
      sectionListParams: {
        page: 1,
        size: 10,
      },
      selectList: [
        // {
        //   title: "批次名称",
        //   type: "select",
        //   requestKey: "planId",
        //   label: "name",
        //   value: "id",
        //   data: [],
        // },
        {
          title: "考点",
          type: "select",
          requestKey: "placeId",
          label: "name",
          value: "id",
          data: [],
        },
      ],
      planInfo: {},
      sectionPlanId:''
    };
  },
  computed: {
    isIndex() {
      return this.$route.name == "section";
    },
  },
  watch: {
    "sectionSelectParams.placeId"(val) {
      this.getSectionList();
    },
    $route: "getPath",
  },
  created() {
    this.sectionPlanId = this.$route.query.id
    this.getPlanSignDateCount()
    this.initData();
    // this.getPlanSiteList();
    this.getSiteData();
  },
  methods: {
    async copyConfig(row) {
      let params = {
        sessionId: row.id,
        planId: this.sectionPlanId,
      }
      const { code } = await copySessionConfigAPI(params);
      if (code == 1) {
        this.$message.success("场次设置复制成功！")
      }
    },


    getPlanSignDateCount() {
      getPlanSignDateCountShow({ planId:this.sectionPlanId }).then((res) => {
        this.appointment= res.data
        if(this.appointment !== null && this.appointment.length){
          this.apptitle = false
        }else{
          this.apptitle = true
        }
      });
    },
    bachOper(val) {
      this.selectSections = val;
    },
    async initData() {
      // 获取所有考试批次
      //   const planData = await this.mixin_getSelectPlan();
      //   this.selectList[0].data = planData;

      // 当前考试批次
      const plan = await getCurrentPlanFn({ planId: this.sectionPlanId });
      this.planInfo = plan.data;
      this.sectionSelectParams.planId = plan.data.id;

      let btnList_01 = [
        {
          title: "编辑",
          disable: (val) => (val.row.publish == 1 ? true : false),
          click: this.editSection,
        },
        {
          title: "删除",
          disableFn: (val) => {
            if (Math.ceil(this.pagination.total / this.sectionListParams.size) != this.sectionListParams.page) {
              return true;
            } else {
              return val.$index !== this.tableData.length - 1;
            }
          },
          click: this.deleteSection,
        },
        {
          title: "复制上一场次配置",
          click: this.copyConfig,
          disableFn: (val) => {
            return val.row.isFirst;
          },
        },
        {
          title: "场次配置",
          click: this.goVenue,
        }, 
      ]      
      let btnList_02 = [
        {
          title: "编辑",
          disable: (val) => (val.row.publish == 1 ? true : false),
          click: this.editSection,
        },
        {
          title: "删除",
          disableFn: (val) => {
            if (Math.ceil(this.pagination.total / this.sectionListParams.size) != this.sectionListParams.page) {
              return true;
            } else {
              return val.$index !== this.tableData.length - 1
            }
          },
          click: this.deleteSection,
        },

      ]

      let btnList_03 = [
        {
          title: "查看场次配置",
          click: this.showVenue
        }
      ]

      let btnList_04 = [
        {
          title: "-",
          disableFn: (val) => {return true}
        }
      ]

      // 显示场次配置的
      if (this.planInfo.examTypeId == 1) {
        if (this.$route.query.flag == 1) {
          this.tableHeader[this.tableHeader.length - 1].btnList = btnList_03;
        } else {
          this.tableHeader[this.tableHeader.length - 1].btnList = btnList_01;
        }
      // 不显示场次配置  
      } else {
        if (this.$route.query.flag == 1) {
          this.tableHeader[this.tableHeader.length - 1].btnList = btnList_04;
        } else {
          this.tableHeader[this.tableHeader.length - 1].btnList = btnList_02;
        }
      }

      /* 
        (1) '已设置' 按钮全开。（新需求）
        (2) 集中机房考试显示 '场次配置相关'，其它不显示（原有需求）
        (3) 考场安排发布/成绩发布的，进来只能见到 ‘查看场次配置’（新需求）
      */

      // this.tableHeader[this.tableHeader.length - 1].btnList = this.planInfo.examTypeId == 1 ?  btnList_01: btnList_02;
      this.getSectionList();
    },
    async getSiteData() {
      this.sectionSelectParams.placeId = "";
      const { data } = await getPlanSite({
        planId: this.sectionPlanId,
      });
      let siteTemp = Array.isArray(data) ? data : [];
      if (siteTemp.length) {
        this.selectList[0].data = [{ id: "", name: "全部" }].concat(siteTemp);
      } else {
        this.selectList[0].data = [];
      }
    },
    addPlanDialog() {
      this.$router.push({
        name: "addSection",
        query: {
          planId: this.sectionPlanId,
        },
      });
    },
    goVenue(row) {
      this.$router.push({
        name: "sectionVenue",
        query: {
          id: row.id,
          planId: this.sectionPlanId,
        },
      });
    },

    showVenue(row) {
      this.$router.push({
        name: "showVenue",
        query: {
          id: row.id,
          planId: this.sectionPlanId
        }
      })
    },

    editSection(row) {
      this.$router.push({
        name: "editSection",
        query: {
          id: row.id,
          planId: this.sectionPlanId,
        },
      });
    },
    checkSection(row) {
      this.$router.push({
        name: "checkSection",
        query: {
          id: row.id,
          planId: this.sectionPlanId,
        },
      });
    },
    deleteSection(row, index) {
      this.$confirm("确定删除该考试场次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { code } = await deleteSessionFn({ sessionId: row.id });
          if (code == 1) {
            this.$message.success("删除成功");
            this.getSectionList();
          }
        })
        .catch(() => {});
    },
    changeSize(num) {
      this.sectionListParams.size = num;
      this.getSectionList();
    },
    changePage(p) {
      this.sectionListParams.page = p;
      this.getSectionList();
    },
    async getSectionList() {
      let params = Object.assign(
        this.sectionListParams,
        this.sectionSelectParams
      );
      const { data } = await getSectionList(params);
      this.tableData = data.records;

      if (this.tableData.length > 0 && this.sectionListParams.page == 1) {
        this.tableData[0].isFirst = true;
      }
      this.pagination.total = data.total;
    },
    getPath() {
      if (this.$route.name == "section") {
        this.getSectionList();
      }
    },
    beforeBatch() {
      if (this.selectSections.length > 0) {
        return true;
      } else {
        this.$message.warning("请先选择场次");
        return false;
      }
    },
    deleteSchool(row) {
      if (row || this.beforeBatch()) {
      } else {
        return false;
      }
      let param = {
        ids: row ? row.id : this.selectIds.join(),
      };
      this.$confirm("确定删除该学校?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { code } = await deleteSchoolFn(param);
          if (code == 1) {
            this.$message.success("删除成功");
            this.getAllSchoolFn();
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.mainCon {
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
  flex: 1;
}
.el-alert {
    margin-bottom: 24px;
    background: #fff5e0;
    border: 1px solid #ff9500;
    
    box-sizing: border-box;
    .importantNote {
      font-size: 14px;
      color: #ff9500;
      margin-left: -10px;
      margin-top: -7px;
     
    }
    /deep/ .el-alert__closebtn {
      top: 17px;
      color: #ff9500;
    }
  }
</style>
